
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/helpcenter",
      function () {
        return require("private-next-pages/helpcenter.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/helpcenter"])
      });
    }
  